import React, { useState, useContext, useEffect, useMemo } from 'react'
import responseErrorMapping from './../../global/error.response.mapping'
import OtpVerify from '../../atomic/otpverify/OtpVerify'
import AtomicButton from '../../atomic/button/AtomicButton';
import { SignUpInfoDataContext } from "../../context-api/SignUpInfoDataProvider";
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import { Alert } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import jwt_decode from "jwt-decode";
import { API_NETWORK_ERROR, localStorageKeys } from "../../global/constants";
import './css/VerifyEmailPage.scss';

import PageBase from '../../composed/pagebase/pagebase';
import { Error404 } from '../../composed/Error404/Error404';
import variables from "../../global/assets/_variables.scss";


function VerifyEmailDirectPage(props) {


    const { generateOtpAPIHandler, verifyEmailOTPAPIHandler, generateOtpAPIResponse, verifyOtpAPIResponse, signupAPIResponse } = useContext(SignUpInfoDataContext);
    const { onCustomerInformationApiHandler, customerInfoData } = useContext(LoginDataContext);
    const OTP_LENGTH = 5;
    const [otp, setOTP] = useState("");
    const [ShowOTPError, setShowOTPError] = useState(false)
    const [ShowSuccessAlert, setShowSuccessAlert] = useState(false)
    const [disabled, setDisabled] = useState(true)
    const { TOKEN } = localStorageKeys;
    const hasTokens = localStorage.getItem(TOKEN);
    const decodedToken = jwt_decode(hasTokens);
    const { email } = decodedToken;
    const { isLoading, data, success, message } = verifyOtpAPIResponse
    const { isLoading: loading, data: chkdata, success: chksucess, message: chkmessage } = generateOtpAPIResponse
    const { success: checkSuccess, loading: checkLoading, data: checkData, errorMessage: checkMessage, noKitchensFound } = customerInfoData
    const custInfoData = checkData?.data || []
    const emailVerificationStatus = custInfoData.user_Info?.email_verified_status === 0


    const submitButtonLabel = "Verify";
    const verifiedSuccessfully = "Successfully verified";
    const otpLabel = "Verify Email address";
    const otpSent = "We have sent OTP code to your email";
    const otpExpiryLabel = "Code will expire in 10 minutes";
    const resendTitle1 = "Did not get the code ?";
    const resendTitle2 = "Resend Code";


    const resendEmailOTP = () => {
        setShowOTPError(false)
        generateOtpAPIHandler(email);
    }


    useEffect(() => {
        setShowSuccessAlert(false)
        onCustomerInformationApiHandler()

        if (success === true && message === 'OTP Verified') {
            setShowOTPError(false)
            setShowSuccessAlert(true)

        }

        if (success === false && message === message) {
            setShowOTPError(true)
        }

    }, [verifyOtpAPIResponse])


    const verifyEmailOTP = async () => {
        await setDisabled(true)
        await verifyEmailOTPAPIHandler(email, otp)

    };

    const MobileIpad = isMobile || isIpad;
    const containerClass = MobileIpad ? "verify-email-page-container-mobile" : "verify-email-page-container";





    // We should capture this if block errors in new relic
    if ((success === false && message === API_NETWORK_ERROR)
        || (chksucess === false && chkmessage === API_NETWORK_ERROR)
        || (checkMessage?.success === false && checkMessage?.CustomMessage === "Something is seriouly wrong,This is last CATCH block")) {
        return (<Error404 />)
    }

    return (
        <PageBase>

            <div className={containerClass}>
                <div style={{ display: 'flex', flexDirection: 'row', }}>
                    <div className='otp-email-icon'></div> <EmailIcon sx={{ marginTop: '26px', fontSize: '25px', color: '#181436' }} />
                    <div className="top-label">{otpLabel}</div>
                </div>
                <div className="otp-sent">{otpSent} {email}</div>

                {(ShowSuccessAlert || !emailVerificationStatus) && (
                    <Alert
                        id="warning-box"
                        severity="success"
                        sx={{
                            border: "solid 2px green",
                            color: 'green',
                            fontSize: "14px",
                            margin: "10px 0px 0px 0px",
                            width: MobileIpad ? '275px' : '320px',

                        }}
                    >{!emailVerificationStatus ? verifiedSuccessfully : responseErrorMapping(message)}</Alert>

                )}

                {ShowOTPError && (
                    <Alert
                        severity="error"
                        sx={{
                            border: `solid 1px ${variables.borderErrorRed}`,
                            color: variables.backGroundErrorRed,
                            fontSize: "14px",
                            margin: "10px 0px 0px 0px",
                            width: MobileIpad ? '275px' : '320px',
                        }}
                    >
                        {<div> {responseErrorMapping(message)}</div>}
                    </Alert>
                )}


                <div className="otp-input-body">

                    <div className="otp-input-section">
                        <OtpVerify digits={OTP_LENGTH} setOTP={setOTP} otp={otp} setDisabled={setDisabled} />
                    </div>

                    <AtomicButton
                        label={(ShowSuccessAlert || !emailVerificationStatus) ? verifiedSuccessfully : submitButtonLabel}
                        style={{ backgroundColor: "#181436", marginTop: '25px', width: MobileIpad ? "275px" : '350px' }}
                        handleSubmit={ShowSuccessAlert ? () => null : verifyEmailOTP}
                        loading={loading}
                        disabled={(ShowSuccessAlert && !emailVerificationStatus || isLoading)}
                    />

                    {(!ShowSuccessAlert && emailVerificationStatus) &&
                        <>
                            <div className="resend-email-section">
                                <span className="resend-title1">{resendTitle1}</span>
                                <button className="resend-title2" onClick={resendEmailOTP}>
                                    {resendTitle2}
                                </button>
                            </div>
                            <div className="otp-expiry-label">{otpExpiryLabel} </div></>}

                </div>
            </div>
        </PageBase>

    )
}

export default VerifyEmailDirectPage